module.exports = __webpack_public_path__ + "static/media/loop_house.2cfe7c5c.svg";